import { useMutation } from 'react-query'

// Services
import { GenerateIntegrationToken } from 'services/api/Auth'

export default () => {
  const {
    mutate: generateIntegrationToken,
    data: generateIntegrationTokenData,
    error: generateIntegrationTokenError,
    isLoading: isGenerateIntegrationTokenLoading,
    isSuccess: isGenerateIntegrationTokenSuccess,
    isError: isGenerateIntegrationTokenError,
  } = useMutation(GenerateIntegrationToken)

  // credentials and isloggedin are set in the loginform component

  return {
    generateIntegrationToken,
    generateIntegrationTokenData,
    generateIntegrationTokenError,
    isGenerateIntegrationTokenLoading,
    isGenerateIntegrationTokenSuccess,
    isGenerateIntegrationTokenError,
  }
}
